import { IContractAddEditRequest } from '../../../../model/scp/contract/request/contract-add-edit-request';
import { IAmendmentAddEditRequest } from '../../../../model/scp/contract/amendment/request/amendment-add-edit-request';
import { ValidationErrors, isBlank, isEmptyId } from '../../../../utils/validation';
import { isEmptyAmount } from '../../shared/scp-utils';

export type ContractField = 'clientId' | 'purchaseId' | 'processNumber' | 'contractEffortNumber' | 'yearContract' | 'codBuyerUnit'
    | 'contractTypeId' | 'categoryProcessId' | 'signDate' | 'effectiveDateStart' | 'effectiveDateEnd' | 'supplierType'
    | 'supplierNumberIdentification' | 'supplierName' | 'object' | 'initialValue' | 'numberPaymentInstallment' | 'globalValue'
    | 'accumulatedValue' | 'typeDocumentId' | 'documentTitle' | 'file';

// Na inclusão o contrato é publicado junto com o documento inicial (tipo, título e arquivo)
export function validateContract(request: IContractAddEditRequest, options: { isEdit: boolean; hasFile: boolean }): ValidationErrors<ContractField> {
    const errors: ValidationErrors<ContractField> = {};
    if (isEmptyId(request.clientId)) errors.clientId = 'Entidade é obrigatória';
    if (isEmptyId(request.purchaseId)) errors.purchaseId = 'Compra ou licitação é obrigatória';
    if (isBlank(request.contractEffortNumber)) errors.contractEffortNumber = 'Nº do empenho é obrigatório';
    if (isBlank(request.processNumber)) errors.processNumber = 'Nº do processo é obrigatório';
    if (isEmptyId(request.yearContract)) errors.yearContract = 'Exercício é obrigatório';
    if (isBlank(request.codBuyerUnit)) errors.codBuyerUnit = 'Unidade é obrigatória';
    if (isEmptyId(request.contractTypeId)) errors.contractTypeId = 'Tipo de contrato é obrigatório';
    if (isEmptyId(request.categoryProcessId)) errors.categoryProcessId = 'Categoria é obrigatória';
    if (!request.signDate) errors.signDate = 'Data de assinatura é obrigatória';
    if (!request.effectiveDateStart) errors.effectiveDateStart = 'Início de vigência é obrigatório';
    if (!request.effectiveDateEnd) errors.effectiveDateEnd = 'Fim de vigência é obrigatório';
    if (request.effectiveDateStart && request.effectiveDateEnd && request.effectiveDateEnd < request.effectiveDateStart) {
        errors.effectiveDateEnd = 'Fim de vigência deve ser posterior ao início';
    }
    if (isBlank(request.supplierType)) errors.supplierType = 'Tipo de fornecedor é obrigatório';
    if (isBlank(request.supplierNumberIdentification)) errors.supplierNumberIdentification = 'Documento do fornecedor é obrigatório';
    if (isBlank(request.supplierName)) errors.supplierName = 'Nome do fornecedor é obrigatório';
    if (isBlank(request.object)) errors.object = 'Objeto é obrigatório';
    if (isEmptyAmount(request.initialValue)) errors.initialValue = 'Valor inicial é obrigatório';
    if (isEmptyAmount(request.numberPaymentInstallment)) errors.numberPaymentInstallment = 'Nº de parcelas é obrigatório';
    if (isEmptyAmount(request.globalValue)) errors.globalValue = 'Valor global é obrigatório';
    if (isEmptyAmount(request.accumulatedValue)) errors.accumulatedValue = 'Valor acumulado é obrigatório';
    if (!options.isEdit) {
        if (isEmptyId(request.typeDocumentId)) errors.typeDocumentId = 'Tipo de documento é obrigatório';
        if (isBlank(request.documentTitle)) errors.documentTitle = 'Título do documento é obrigatório';
        if (!options.hasFile) errors.file = 'Arquivo é obrigatório';
    }
    return errors;
}

export type AmendmentField = 'amendmentTypeId' | 'amendmentNumber' | 'signDate' | 'amendmentObject' | 'supplierType'
    | 'supplierNumberIdentification' | 'supplierName' | 'justification';

// A alteração de um termo já publicado exige justificativa
export function validateAmendment(request: IAmendmentAddEditRequest, isEdit: boolean): ValidationErrors<AmendmentField> {
    const errors: ValidationErrors<AmendmentField> = {};
    if (isEmptyId(request.amendmentTypeId)) errors.amendmentTypeId = 'Tipo de aditivo é obrigatório';
    if (isBlank(request.amendmentNumber)) errors.amendmentNumber = 'Número do termo é obrigatório';
    if (!request.signDate) errors.signDate = 'Data de assinatura é obrigatória';
    if (isBlank(request.amendmentObject)) errors.amendmentObject = 'Objeto do termo é obrigatório';
    if (isBlank(request.supplierType)) errors.supplierType = 'Tipo de fornecedor é obrigatório';
    if (isBlank(request.supplierNumberIdentification)) errors.supplierNumberIdentification = 'Documento do fornecedor é obrigatório';
    if (isBlank(request.supplierName)) errors.supplierName = 'Nome do fornecedor é obrigatório';
    if (isEdit && isBlank(request.justification)) errors.justification = 'Justificativa é obrigatória para alterar o termo';
    return errors;
}
